<!--footer section -->
<footer [class]="class">
  <section class="section-b-space light-layout">
    <div class="container">
      <div class="row footer-theme partition-f">
        <div class="col-lg-4 col-md-6">
          <div class="footer-title footer-mobile-title">
            <h4>about</h4>
          </div>
          <div class="footer-contant">
            <div class="footer-logo">
              <img [src]="themeLogo" alt="logo">
            </div>
            <p>Powered By ...</p>
            <p>{{ footerDescription }}</p>
            <div *ngIf="true" class="footer-social footer-social-display ">
              <ul>
                <li>
                  <a href="https://www.facebook.com/allxsmedia"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://twitter.com/Myallxs"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/allxsofficial"><i class="fa fa-instagram"
                      aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
            <div *ngIf="false" class="footer-social footer-social-display ">
              <ul>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61578119581505"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="https://x.com/MkhontoweSizwex"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                </li>
                <li *ngIf="false">
                  <a href="https://www.instagram.com/allxsofficial"><i class="fa fa-instagram"
                      aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col offset-xl-5">
          <div class="sub-title">
            <div class="footer-title">
              <h4>Contact Us</h4>
            </div>
            <div class="footer-contant">
              <ul class="contact-list">
                <li><i class="fa fa-map-marker"></i>{{ companyName }}</li>
                <li *ngIf="whatsAppContact && whatsAppContact.length > 10"><i class="fa fa-phone"></i>WhatsApp Support:
                  {{ whatsAppContact }}</li>
                <li><i class="fa fa-envelope-o"></i>Email Us: <a>{{ contactUsEmail }}</a></li>
                <li *ngIf="false"><i class="fa fa-envelope-o"></i>Email Us: <a href="mailto:info@mkparty.co.za"> info&#64;mkparty.co.za</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="sub-footer">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="footer-end">
            <p><i class="fa fa-copyright" aria-hidden="true"></i> {{ today | date:'y'}} Powered by Allxs {{version}}</p>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="payment-card-bottom">
            <ul>
              <li>
                <a><img src="assets/images/icon/visa.png" alt=""></a>
              </li>
              <li>
                <a><img src="assets/images/icon/mastercard.png" alt=""></a>
              </li>
              <li>
                <a><img src="assets/images/icon/paypal.png" alt=""></a>
              </li>
              <li>
                <a><img src="assets/images/icon/american-express.png" alt=""></a>
              </li>
              <li>
                <a><img src="assets/images/icon/discover.png" alt=""></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<!--footer section end -->